module.exports = __webpack_public_path__ + "static/img/海报设计-平面合成海报_new.6988e71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10001/海报设计-平面合成海报_new.png
// module id = idkR
// module chunks = 1